<template>
 <div class="service-details-sidebar mr-50">
                        <div class="service-category-widget">
                            <ul>
                                <li><i class="fal fa-camera"></i>Picture Menu App</li>
                                <li><i class="fal fa-cheeseburger"></i>Real Pictures of Real Food</li>
                                <li><i class="fal fa-comments"></i>Read Comments, Leave Feedback</li>
                                <li><i class="fal fa-star"></i>Rate Food</li>
                                <li><i class="fal fa-dollar-sign"></i>Earn eGifts</li>
                            </ul>
                        </div>
                        <!-- <div class="service-download-widget">
                            <a href="#">
                                <i class="fal fa-download"></i>
                                <span>Zoom into Famous Local Dishes</span>
                            </a>
                        </div> -->
                        <div class="service-download-widget">
                            <a href="#">
                                <i class="fal fa-comment-alt-dollar"></i>
                                <span>Earn $1 for Every Picture Submitted & Approved</span>
                            </a>
                        </div>
                    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>